import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
// import "./VFC.css";
import Preloader from "../../shared/PreLoaders";
import { AuthContext } from "../../Context/AuthContext";
import { Authorization } from "../../Context/Authorization";

const EditVFC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { access } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    vfcName: "",
    vfcCode: "",
    rangeId: "",
    location: "",
    address: "",
    village: "",
    panchayath: "",
    thaluk: "",
    pinCode: "",
    dateOfEstablishment: "",
    bankName: "",
    branch: "",
    accountNumber: "",
    ifscCode: "",
    registrationNo: "",
    registrationDate: "",
    totalFamily: "",
    totalPopulation: "",
    vfcFamily: "",
  });
  const [errors, setErrors] = useState({});
  const [rangeOptions, setRangeOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  // Simplified validation function
  const validateForm = (formData) => {
    const newErrors = {};
    if (!formData.vfcName) {
      newErrors.vfcName = "VFC name is required";
    }
    if (!formData.vfcCode) {
      newErrors.vfcCode = "VFC code is required";
    }
    // else if (formData.vfcCode.length !== 2) {
    //   newErrors.vfcCode = "VFC code must be 2 characters long";
    // }
    if (!formData.rangeId) {
      newErrors.rangeId = "Please select Range Id";
    }
    if (!formData.location) {
      newErrors.location = "Please select Location";
    }
    if (!formData.address) {
      newErrors.address = "Please select Address";
    }
    if (!formData.village) {
      newErrors.village = "Please select Village";
    }
    if (!formData.panchayath) {
      newErrors.panchayath = "Please select Panchayath";
    }
    if (!formData.thaluk) {
      newErrors.thaluk = "Please select Thaluk";
    }
    if (!formData.pinCode) {
      newErrors.pinCode = "Please select Pincode";
    }
    if (!formData.dateOfEstablishment) {
      newErrors.dateOfEstablishment = "Please select DateOfEstablishment";
    }
    // if (!formData.bankName) {
    //   newErrors.bankName = "Please select BankName";
    // }
    // if (!formData.branch) {
    //   newErrors.branch = "Please select Branch";
    // }
    // if (!formData.accountNumber) {
    //   newErrors.accountNumber = "Please select AccountNumber";
    // }
    // if (!formData.ifscCode) {
    //   newErrors.ifscCode = "Please select IFSC Code Id";
    // }
    // if (!formData.registrationNo) {
    //   newErrors.registrationNo = "Please Enter Registration No";
    // }
    // if (!formData.registrationDate) {
    //   newErrors.registrationDate = "Please Enter Registration Date";
    // }
    // if (!formData.totalFamily) {
    //   newErrors.totalFamily = "Please Enter Total Family";
    // }
    // if (!formData.totalPopulation) {
    //   newErrors.totalPopulation = "Please Enter Total population";
    // }
    // if (!formData.vfcFamily) {
    //   newErrors.vfcFamily = "Please Enter VFC Family";
    // }
    return newErrors;
  };

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs/${id}`, Config);
        const vfcData = response.data.vfc;

        // Convert the date to the required format (yyyy-MM-dd)
        const formattedDate = vfcData.dateOfEstablishment.split("T")[0];

        setFormData({ ...vfcData, dateOfEstablishment: formattedDate });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching VFC data", error);
        setLoading(false);
      }
    };

    const fetchRanges = async () => {
      setLoading(true);
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/ranges`, Config);
        const data = response.data;

        if (Array.isArray(data)) {
          setRangeOptions(data);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    if (id) {
      fetchVfc();
    }
    fetchRanges();
  }, [id]); // Ensure id is included in the dependency arrays

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all Details");
      return;
    }

    try {
      const Config = Authorization();
      const response = await axios.put(
        `${Api}/api/vfcs/${id}`,
        Config,
        formData
      );
      if (response.status === 200) {
        toast.success("Updated Successfully");
        navigate("/dashboard/vfc/manage"); // Redirect to the VFC list or another appropriate page
      } else {
        console.error("Error updating form:", response.statusText);
        toast.error("Error updating form");
      }
    } catch (error) {
      console.error("Error updating form:", error);
      toast.error("Error updating form");
    }
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> All VFC </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              All VFC
            </li>
          </ol>
        </nav>
      </div>
      <Container>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <p className="card-description">VFC Registration Form</p>
              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="vfcName">VFC Name</label>
                      <Form.Control
                        type="text"
                        id="vfcName"
                        placeholder="Enter VFC Name"
                        value={formData.vfcName}
                        onChange={handleChange}
                        isInvalid={!!errors.vfcName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.vfcName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="vfcCode">VFC Code</label>
                      <Form.Control
                        type="text"
                        id="vfcCode"
                        placeholder="Enter VFC Code"
                        value={formData.vfcCode}
                        onChange={handleChange}
                        isInvalid={!!errors.vfcCode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.vfcCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="rangeId">Range</label>
                      <Form.Control
                        as="select"
                        id="rangeId"
                        value={formData.rangeId}
                        onChange={handleChange}
                        isInvalid={!!errors.rangeId}
                      >
                        <option value="">Select Range</option>
                        {rangeOptions.map((range) => (
                          <option key={range._id} value={range._id}>
                            {range.rangeCode}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.rangeId}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="location">Location</label>
                      <Form.Control
                        type="text"
                        id="location"
                        placeholder="Enter Location"
                        value={formData.location}
                        onChange={handleChange}
                        isInvalid={!!errors.location}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.location}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="address">Address</label>
                      <Form.Control
                        type="text"
                        id="address"
                        placeholder="Enter Address"
                        value={formData.address}
                        onChange={handleChange}
                        isInvalid={!!errors.address}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="village">Village</label>
                      <Form.Control
                        type="text"
                        id="village"
                        placeholder="Enter Village"
                        value={formData.village}
                        onChange={handleChange}
                        isInvalid={!!errors.village}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.village}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="panchayath">Panchayath</label>
                      <Form.Control
                        type="text"
                        id="panchayath"
                        placeholder="Panchayath "
                        value={formData.panchayath}
                        onChange={handleChange}
                        isInvalid={!!errors.panchayath}
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.panchayath}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="thaluk">Thaluk</label>
                      <Form.Control
                        type="text"
                        id="thaluk"
                        placeholder="Enter thaluk"
                        value={formData.thaluk}
                        onChange={handleChange}
                        isInvalid={!!errors.thaluk}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.thaluk}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="pinCode">PinCode</label>
                      <Form.Control
                        type="text"
                        id="pinCode"
                        placeholder="Enter PinCode"
                        value={formData.pinCode}
                        onChange={handleChange}
                        isInvalid={!!errors.pinCode}
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.pinCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="dateOfEstablishment">
                        Date Of Establishment
                      </label>
                      <Form.Control
                        type="text"
                        id="dateOfEstablishment"
                        placeholder="Enter Date Of Establishment"
                        value={formData.dateOfEstablishment}
                        onChange={handleChange}
                        isInvalid={!!errors.dateOfEstablishment}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.dateOfEstablishment}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="bankName">Bank Name</label>
                      <Form.Control
                        type="text"
                        id="bankName"
                        placeholder="Enter Bank Name"
                        value={formData.bankName}
                        onChange={handleChange}
                        isInvalid={!!errors.bankName}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.bankName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="branch">Branch</label>
                      <Form.Control
                        type="text"
                        id="branch"
                        placeholder="Enter branch"
                        value={formData.branch}
                        onChange={handleChange}
                        isInvalid={!!errors.branch}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.branch}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="accountNumber">Account Number</label>
                      <Form.Control
                        type="text"
                        id="accountNumber"
                        placeholder="Enter Account Number"
                        value={formData.accountNumber}
                        onChange={handleChange}
                        isInvalid={!!errors.accountNumber}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.accountNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="ifscCode">IFSC Code</label>
                      <Form.Control
                        type="text"
                        id="ifscCode"
                        placeholder="Enter IFSC Code"
                        value={formData.ifscCode}
                        onChange={handleChange}
                        isInvalid={!!errors.ifscCode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.ifscCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="registrationNo">
                        Registration Number
                      </label>
                      <Form.Control
                        type="text"
                        id="registrationNo"
                        placeholder="Enter Registration Number"
                        value={formData.registrationNo}
                        onChange={handleChange}
                        isInvalid={!!errors.registrationNo}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.registrationNo}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="registrationDate">
                        Registration Date
                      </label>
                      <Form.Control
                        type="text"
                        id="registrationDate"
                        placeholder="Enter registrationDate"
                        value={formData.registrationDate}
                        onChange={handleChange}
                        isInvalid={!!errors.registrationDate}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.registrationDate}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="totalFamily">Total Family</label>
                      <Form.Control
                        type="text"
                        id="totalFamily"
                        placeholder="Enter Total Family"
                        value={formData.totalFamily}
                        onChange={handleChange}
                        isInvalid={!!errors.totalFamily}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.totalFamily}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="totalPopulation">Total Population</label>
                      <Form.Control
                        type="text"
                        id="totalPopulation"
                        placeholder="Enter totalPopulation"
                        value={formData.totalPopulation}
                        onChange={handleChange}
                        isInvalid={!!errors.totalPopulation}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.totalPopulation}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="vfcFamily">VFC Family</label>
                      <Form.Control
                        type="text"
                        id="vfcFamily"
                        placeholder="Enter VFC Family"
                        value={formData.vfcFamily}
                        onChange={handleChange}
                        isInvalid={!!errors.vfcFamily}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.vfcFamily}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-outline-primary btn-icon-text mt-3"
                >
                  <i className="mdi mdi-file-check btn-icon-prepend"></i>
                  Submit
                </button>
                <button className="btn btn-light mt-3">Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EditVFC;
